import React from 'react';
import { translate } from '../../i18n';
import { ITranslations } from '../../i18n/config';
import BackLink from '../BackLink';
import { BackLinkProps } from '../BackLink/BackLink';
import BannerLayout from '../BannerLayout';
import Navigation from '../Navigation';
import { useSections } from './hooks';
import { OverviewLayoutSectionProps } from './OverviewLayoutSection';
import './style.scss';

export interface OverviewLayoutProps extends Partial<BackLinkProps> {
  title: ITranslations;
  description?: ITranslations;
  children:
    | React.ReactElement<OverviewLayoutSectionProps>
    | (false | React.ReactElement<OverviewLayoutSectionProps>)[]
    | false
    | undefined;
  wide?: boolean;
  noNavigation?: boolean;
}
const OverviewLayout: React.FC<OverviewLayoutProps> = ({
  children,
  title,
  description,
  backAction,
  backLabel,
  wide,
  noNavigation,
}) => {
  const { sections, aside } = useSections(children);

  return (
    <BannerLayout title={translate(title)} metaTitle={title} metaDescription={description}>
      {backAction && backLabel && <BackLink backAction={backAction} backLabel={backLabel} />}

      {!noNavigation && (
        <aside className="col-xs-12 col-lg-3 ckp-o-overview-layout__aside">
          <Navigation sections={sections} />
        </aside>
      )}

      <main
        id="main-content"
        className={`col-xs-12 ${
          wide || noNavigation ? 'col-lg-9' : 'col-lg-6'
        } ckp-o-overview-layout__main`}
        role="main"
      >
        {sections}
      </main>

      {!wide && aside && (
        <aside className="col-xs-12 col-lg-3 ckp-o-overview-layout__aside">{aside}</aside>
      )}
    </BannerLayout>
  );
};

export default OverviewLayout;
